import { h, Component } from 'preact';

class ServiceWrapper extends Component {
	componentDidMount(){
		if(typeof this.props.loading==='function') this.props.loading();
	}
	render() {
		return (
			<div class="min_height_services">
				<div id="main">
					<div class="container">
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}
}

export default ServiceWrapper



// WEBPACK FOOTER //
// ./routes/services/serviceWrapper.js